import { useTranslation } from 'react-i18next';
import { ProvenanceBadge } from '@/components/trust/ProvenanceBadge';

/** Secondary metrics — deliberately quieter than the headline result. */
export function MetricsStrip({ results, durationHints = [] }) {
  const { t } = useTranslation();

  const items = [
    { id: 'effort', label: t('results.totalEffort'), value: results.totalEffort,
      unit: t('results.personDays'), provenance: 'MODELLED' },
    { id: 'duration', label: t('results.duration'), value: results.totalDurationWeeks,
      unit: t('estimates.weeks'), provenance: 'MODELLED', hints: durationHints },
    { id: 'fte', label: t('results.fteRequired'), value: results.fteRequired,
      unit: 'FTE', provenance: 'MODELLED' },
    { id: 'audit', label: t('trust.mAuditDays'), value: results.auditDays,
      unit: t('estimates.days'), provenance: 'ISO_DERIVED' },
  ];

  return (
    <section
      className="border border-[#DDE1E5] rounded-lg overflow-hidden bg-[#DDE1E5] grid grid-cols-1 sm:grid-cols-2 gap-px"
      data-testid="estimate-metrics-strip"
    >
      {items.map(item => (
        <div key={item.id} className="bg-white p-4 min-w-0" data-testid={`metric-${item.id}`}>
          <div className="text-[11px] uppercase tracking-[0.06em] text-[#66707A] leading-tight"
               style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
            {item.label}
          </div>
          <div className="mt-1.5 flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5 min-w-0">
            <span className="text-2xl font-semibold text-[#171A1D]"
                  style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
              {item.value}
            </span>
            <span className="text-xs text-[#8A929B] min-w-0">{item.unit}</span>
          </div>
          <div className="mt-2 flex flex-wrap items-center gap-1.5">
            <ProvenanceBadge provenance={item.provenance} />
            {(item.hints || []).map(hint => (
              <span key={hint} className="text-[10px] text-[#66707A] bg-[#F5F6F7] border border-[#DDE1E5] px-1.5 py-0.5 rounded-sm">
                {hint}
              </span>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
